module.exports = __webpack_public_path__ + "static/media/01.0c538dd9.jpg";